import React from 'react';
import { IDadosRetornoAgendamentosDiaItem } from '.';

interface IExibeDadosTabela {
  titulo: string;
  tituloItem: string;
  dados?: IDadosRetornoAgendamentosDiaItem[];
}

const ExibeDadosTabela: React.FC<IExibeDadosTabela> = ({
  titulo,
  tituloItem,
  dados,
}) => {
  const totalRegistros = dados?.reduce((tot, item) => {
    return tot + Number(item.total || 0) || 0;
  }, 0);
  return (
    <>
      {dados && dados.length > 0 && (
        <div className="bg-white border p-2" style={{ minHeight: '150px' }}>
          <>
            <h4>{titulo}</h4>
            <p className="mb-0">
              <b>Total de {totalRegistros} agendamentos</b>
            </p>
            <table
              className="table table-hover table-sm table-font-small table-bordered"
              style={{ borderWidth: '0px' }}
            >
              <thead>
                <tr className="text-center">
                  <th style={{ width: '100%' }}>{tituloItem}</th>
                  <th style={{ minWidth: '150px' }}>Total</th>
                </tr>
              </thead>
              <tbody>
                {dados &&
                  dados.map(rel => (
                    <tr
                      key={`loginUsu-${rel.item}`}
                      style={{ fontSize: '.7rem', height: '30px' }}
                    >
                      <td>{rel.item}</td>
                      <td>{rel.total}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </>
        </div>
      )}
    </>
  );
};

export default ExibeDadosTabela;
